<template>
  <div class="donate-wrapper">
    <!-- 悬浮按钮 -->
    <button class="donate-btn" @click="showModal = true" :title="$t('donate.title')">
      <span class="donate-icon">☕</span>
      <span class="donate-text">{{ $t('donate.button') }}</span>
    </button>

    <!-- 弹窗遮罩 -->
    <div class="donate-overlay" v-if="showModal" @click="showModal = false">
      <div class="donate-modal" @click.stop>
        <button class="modal-close" @click="showModal = false">&times;</button>
        <div class="modal-header">
          <span class="modal-emoji">☕</span>
          <h3>{{ $t('donate.title') }}</h3>
          <p class="modal-subtitle">{{ $t('donate.subtitle') }}</p>
        </div>
        <div class="modal-body">
          <div class="qr-tabs">
            <button 
              class="qr-tab" 
              :class="{ active: activeTab === 'wechat' }" 
              @click="activeTab = 'wechat'"
            >
              <span class="tab-icon">💬</span>
              {{ $t('donate.wechat') }}
            </button>
            <button 
              class="qr-tab" 
              :class="{ active: activeTab === 'alipay' }" 
              @click="activeTab = 'alipay'"
            >
              <span class="tab-icon">💙</span>
              {{ $t('donate.alipay') }}
            </button>
          </div>
          <div class="qr-content">
            <div class="qr-image-wrapper" v-if="activeTab === 'wechat'">
              <img src="/donate-wechat.png" :alt="$t('donate.wechat')" class="qr-image" />
            </div>
            <div class="qr-image-wrapper" v-else>
              <img src="/donate-alipay.png" :alt="$t('donate.alipay')" class="qr-image" />
            </div>
            <p class="qr-hint">{{ $t('donate.scanHint') }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <p>{{ $t('donate.thanks') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DonateButton',
  data() {
    return {
      showModal: false,
      activeTab: 'wechat'
    }
  },
  watch: {
    showModal(val) {
      // 打开弹窗时禁止背景滚动
      document.body.style.overflow = val ? 'hidden' : ''
    }
  }
}
</script>

<style scoped>
/* 打赏按钮 */
.donate-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #f59e0b, #f97316);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

.donate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
}

.donate-btn:active {
  transform: translateY(0);
}

.donate-icon {
  font-size: 18px;
}

/* 弹窗遮罩 */
.donate-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 弹窗主体 */
.donate-modal {
  background: var(--bg-secondary);
  border-radius: 20px;
  padding: 32px;
  width: 90%;
  max-width: 400px;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: var(--bg-tertiary);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  transition: all 0.2s;
}

.modal-close:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

/* 弹窗头部 */
.modal-header {
  text-align: center;
  margin-bottom: 24px;
}

.modal-emoji {
  font-size: 40px;
  display: block;
  margin-bottom: 12px;
}

.modal-header h3 {
  font-size: 22px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.modal-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
}

/* Tab 切换 */
.qr-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.qr-tab {
  flex: 1;
  padding: 10px 16px;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.qr-tab:hover {
  border-color: var(--accent-color);
}

.qr-tab.active {
  border-color: var(--accent-color);
  background: var(--accent-light);
  color: var(--accent-color);
}

.tab-icon {
  font-size: 16px;
}

/* 二维码区域 */
.qr-content {
  text-align: center;
}

.qr-image-wrapper {
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: inline-block;
  margin-bottom: 12px;
}

.qr-image {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: 8px;
}

.qr-hint {
  font-size: 13px;
  color: var(--text-muted);
}

/* 弹窗底部 */
.modal-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.modal-footer p {
  font-size: 13px;
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .donate-modal {
    padding: 24px;
    margin: 0 16px;
  }

  .qr-image {
    width: 160px;
    height: 160px;
  }

  .donate-text {
    display: none;
  }

  .donate-btn {
    padding: 10px 14px;
  }
}
</style>
